export default __webpack_public_path__ + "static/donate-banner-bg-82877e313f53e01073cf6e03febac793.jpg";